import React from 'react'
import './sidebar.scss'

export type SidebarContentProps = {
  name?: string
  children?: React.ReactNode
} & React.HTMLAttributes<HTMLDivElement>

const SidebarContent: React.FC<SidebarContentProps> = ({ children, ...rest }) => {
  return (
    <div className="tp-sidebar__content" {...rest}>
      <div className="tp-sidebar__content-body">{children ?? null}</div>
    </div>
  )
}

export default SidebarContent
